<template>
  <div>
    <input type="text" class="uk-input" v-model="model" name="email" />
  </div>
</template>

<script>
export default {
  name: "email",
  data() {
    return {
      model: null
    };
  },
  props: ["input", "form", "value"],
  created() {
    if (this.value) {
      this.model = this.value;
    }
  },
  watch: {
    form() {
      if (this.form) {
        this.model = null;
      }
    },
    model() {
      this.$parent.$emit("changed", {
        name: this.input.name,
        value: this.model
      });
    }
  }
};
</script>

<style></style>
